import React, { act } from 'react'
import { Popup } from 'antd-mobile'
import URI from 'urijs';
import { NavLink } from '../../lib/Navigation.js';
import { useLocalStorageState } from 'ahooks';
import Dialog from '../../lib/Dialog';
import './css/NewCommunity.css'
import { BoxType } from '../../BoxType.js';

export default function PublishAlert(props) {

  const { visible, onClose, activeItem, isMainCommunity } = props;
  const [cachePublish_from_game, setCachePublish_from_game] = useLocalStorageState('publish_from_game', {})
  // const disableUrl = isMainCommunity ? '' : '&disable=1';
  const disableUrl = '';
  const is_display_activetab = '&is_display_activetab=' + activeItem?.is_display_activetab;
  
  return (
    <div>
      <Popup
        className='publish-alert-wrapper'
        getContainer={document.getElementById('root')}
        visible={visible}
        bodyStyle={{ borderTopLeftRadius: '13px', borderTopRightRadius: '13px' }}
        onMaskClick={() => {
          onClose();
        }}
      >
        <div className="publish-alert">
          <div className="publish-mask" onClick={() => onClose()}></div>
          <div className="publish-container">
            <div className="header">
              <NavLink onClick={() => onClose()} to={URI('https://api3.app.wakaifu.com/communityRewards').toString()}
                iframe={{ title: '奖励规则' }}
                user={false}
              >
                <div className="rule">
                  <img src="resources/community/rule.png" alt="" />
                  &nbsp;<span>奖励规则</span>
                </div>
              </NavLink>

              <div className="close" onClick={() => onClose()}>
                <img src="resources/community/close.png" alt="" />
              </div>
            </div>
            <div className="content">
              <NavLink
                onClick={() => {
                  setCachePublish_from_game(activeItem);
                }}
                to={'/publish?tagid=1&topic_id=' + activeItem?.maiyou_gameid + disableUrl + is_display_activetab}>
                <div className="item" onClick={() => onClose()}>
                  <img className='icon' src={`resources/251009/${BoxType}leave_comment.png`} alt="" />
                  <img className='logo' src="resources/community/prizes.png" alt="" />
                  <div className="text">发评论</div>
                </div>
              </NavLink>
              <NavLink
                onClick={() => {
                  if (!activeItem?.played) {
                    Dialog.info('只有玩过该游戏才能发布攻略！')
                    return
                  }
                  setCachePublish_from_game(activeItem);
                }}
                to={!activeItem?.played ? '' : '/publish?tagid=2&topic_id=' + activeItem?.maiyou_gameid + disableUrl + is_display_activetab}>
                <div className="item" onClick={() => onClose()}>
                  <img className='icon' src={`resources/251009/${BoxType}leave_strategy.png`} alt="" />
                  <img className='logo' src="resources/community/prizes.png" alt="" />
                  <div className="text">发攻略</div>
                </div>
              </NavLink>
              <NavLink
                onClick={() => {
                  setCachePublish_from_game(activeItem);
                }}
                to={'/publish?tagid=3&topic_id=' + activeItem?.maiyou_gameid + disableUrl + is_display_activetab}>
                <div className="item" onClick={() => onClose()}>
                  <img className='icon' src={`resources/251009/${BoxType}leave_question.png`} alt="" />
                  <div className="text">问大神</div>
                </div>
              </NavLink>
            </div>
            <div className="cancel" onClick={() => onClose()}>取消</div>
          </div>
        </div>
      </Popup>
    </div>
  )
}